import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { FeedyardSummaryDashboard } from "@/bookings/FeedyardSummaryDashboard";
import { SUMMARY_SORT_FIELDS } from "@/bookings/FeedyardSummaryDashboard/shared/sortFields";
import { MONTHS } from "@/bookings/FeedyardSummaryDashboard/utils/monthUtils";

export const Route = createFileRoute("/(authed)/_layout/bookings/_tabbed/summary")({
  validateSearch: z.object({
    view: z.enum(["destinations", "sources"]).prefault("destinations").catch("destinations"),
    month: z.enum(MONTHS).optional().catch(undefined),
    year: z.int().min(2020).max(2030).optional().catch(undefined),
    fromDate: z.string().optional(),
    toDate: z.string().optional(),
    sortField: z.enum(SUMMARY_SORT_FIELDS).optional().catch(undefined),
    sortDesc: z.boolean().optional(),
  }),
  component: FeedyardSummaryDashboard,
  loader: () => {
    return {
      crumb: "Summary",
    };
  },
});
